import { render } from "./transactionPage.vue?vue&type=template&id=04acc05c"
import script from "./transactionPage.vue?vue&type=script&lang=js"
export * from "./transactionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__